import { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { IconButton, List, ListItem, ListItemText, ListItemIcon, Divider, Drawer } from "@mui/material";
import EventsEmitter from "events/EventsEmitter";
import {
    Home,
    Tv,
    TableChart,
    Folder,
    Schedule,
    Warning,
    ChevronLeft,
    ChevronRight,
    EventNote,
    Settings,
    Help,
} from "@mui/icons-material";
import { Logo } from "constants/ui";
import themeCfg from "config/theme.json";
import commonStyles, { drawerWidth, menuItemButtonsColor, headerHeight, menuItemWidth } from "styles/common";
import { themeHandler } from "styles/theme";

const sideStyles = makeStyles()((theme: any) => ({
    sideRoot: {
        display: "inline-flex",
        float: "left",
        height: "100%",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        minHeight: 40,
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: 56,
        minHeight: 40,
    },
    header: {
        position: "relative",
        display: "inline-flex",
        height: headerHeight,
        minHeight: headerHeight,
        alignItems: "center",
        backgroundColor: themeCfg.sideTopColor,
        borderRightColor: themeCfg.sideTopColor + " !important",
    },
    list: {
        width: "100%",
        minWidth: "100%",
        position: "relative",
        height: "100% !important",
        marginTop: "20px",
        display:'flex',
        flexDirection : 'column',
    },
    link: {
        textDecoration: "none",
        color: menuItemButtonsColor,
    },
    help: {
        // position: "absolute",
        // bottom: 88,
        // width: menuItemWidth
        marginTop: 'auto !important',
    },
    settings: {
        // position: "absolute",
        // bottom: 40,
        // width: menuItemWidth
        marginBottom : 30
    },
}));

const SideMenu: any = [
    { id: "home", text: "Home", icon: <Home />, link: "/" },
    { id: "workflows", text: "Workflows", icon: <EventNote />, link: "/workflows" },
    { id: "views", text: "Views", icon: <Tv />, link: "/views" },
    // { id:"projects", text: "Projects", icon: <Public />, link: "/projects" },
    { id: "reports", text: "Reports", icon: <TableChart />, link: "/reports" },
    { id: "catalog", text: "Catalog", icon: <Folder />, link: "/catalog" },
    { id: "pending", text: "Pending", icon: <Schedule />, link: "/pending" },
    { id: "issues", text: "Issues", icon: <Warning />, link: "/issues" },
    { id: "help", text: "Help", icon: <Help />, link: "https://help.voxelspace.com"},
    { id: "settings", text: "Settings", icon: <Settings />, link: "/settings" },
];

export default function Side(props: { open: boolean; onClose: any }) {
    const { classes, cx } = sideStyles();
    const { classes: common } = commonStyles();
    const { open, onClose } = props;

    const history = useHistory();
    const pathname = history.location.pathname;
    var path = pathname.split("/")[1];
    if (path === "/app/" || path === "/") {
        path = "home";
    }

    useEffect(() => {
        EventsEmitter.on("changeTab", setSelectedTab);
        EventsEmitter.on("changeTheme", setSelectedTab);
        return () => {
            EventsEmitter.removeEventListener("changeTab", setSelectedTab);
            EventsEmitter.removeEventListener("changeTheme", setSelectedTab);
        };
    }, []);

    const [selectedTab, setSelectedTab] = useState(path === "" || path === "/" ? "home" : path);
    console.log("selectedTab:", selectedTab.toLowerCase());
    //console.log("path:", path);

    const changeTab = (tab: string) => {
        setSelectedTab(tab);
        EventsEmitter.emit("changeTab", tab);
    };

    return (
        <div className={classes.sideRoot}>
            <Drawer
                variant="permanent"
                className={cx(classes.drawer, {
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                })}
                classes={{
                    paper: cx({
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    }),
                }}
            >
                <div className={classes.header}>
                    <img
                        src={Logo}
                        alt={themeCfg.logoTitle}
                        style={{
                            display: !open ? "none" : "block",
                            paddingLeft: 15,
                            marginRight: 10,
                            width: themeCfg.logoWidth,
                            height: themeCfg.logoHeight,
                        }}
                    />
                    <IconButton onClick={onClose} style={{ minWidth: 40 }}>
                        {themeHandler.getUserTheme().direction === "rtl" ? (
                            <ChevronRight style={{color:"#ccc"}}/>
                        ) : (
                            <ChevronLeft
                                style={{
                                    display: !open ? "none" : "block",
                                    color:"#ccc"
                                }}
                            />
                        )}
                    </IconButton>
                </div>
                {/* <Divider style={{ backgroundColor: "#E5E9F1", border: "none", height: 1, margin: 0, flexShrink: 0 }} /> */}
                <List className={classes.list}>
                    {Object.values(SideMenu).map((entry: any) => (
                        
                        <div style={{ marginTop : entry.id === "help" ? 'auto' : 0, marginLeft: 'auto', marginRight:'auto', width: menuItemWidth }} key={entry.id}>
                            <div
                                key={entry.id}
                                className={
                                    entry.id === "settings" ? classes.settings : entry.id === "help" ? classes.help : ""
                                } 
                            >              
                                <NavLink
                                    to={entry.link}
                                    target={entry.id === "help" ? "_blank" : ""}
                                    className={classes.link}
                                    onClick={(e: any) => changeTab(entry.id)}
                                >
                                    <ListItem 
                                        className={
                                            selectedTab.toLowerCase() === entry.id ? common.primarySelectedBgColor : common.primarySelectedBgNoColor
                                        }
                                    >
                                        <ListItemIcon
                                            className={
                                                selectedTab.toLowerCase() === entry.id ? common.primarySelectedColor : common.primaryWhiteColor
                                            }
                                        >
                                            {entry.icon}
                                        </ListItemIcon>
                                        <ListItemText  
                                            className={
                                                selectedTab.toLowerCase() === entry.id ? common.primarySelectedColor : common.primaryWhiteColor
                                            } primary={entry.text} />
                                    </ListItem>
                                </NavLink>
                                <Divider className={common.menuDivider} />
                            </div>
                        </div>
                    ))}
                </List>
            </Drawer>
        </div>
    );
}
